import React, {useEffect} from 'react';
import {connect} from 'react-redux';
import {
  Switch,
  Route,
  Redirect,
  match,
} from 'react-router-dom';
import {ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';

import {AppState} from './Store';
import {loadDashboardCreator} from './Store/Admin/Actions';
import {Dashboard as DashboardModel} from './Services/DashboardService';

import Header from './Admin/Header';
import Dashboard from './Admin/Dashboard';
import Articles from './Admin/Articles';
import Authors from './Admin/Authors';
import Categories from './Admin/Categories';
import Surveys from './Admin/Surveys';
import Metrics from './Admin/Metrics';
import Errors from './Admin/Errors';
import AdminLink from './Components/AdminLink';

type TParams = {
};

interface AdminProps {
  match: match<TParams>;

  admin: boolean;
  loadDashboard: () => Promise<DashboardModel>;
}

function Admin({match, admin, loadDashboard}: AdminProps) {
  useEffect(() => {
    loadDashboard();
  }, [loadDashboard]);

  if (!admin) {
    return (
      <Redirect to="/public" />
    );
  }

  const {path} = match;

  return (
    <React.Fragment>
      <AdminLink to="/public" text="Client" />
      <div className="main-content-wrapper section-padding-100">
        <div className="container admin">
          <Header />
          <Switch>
            <Route exact path={`${path}/`} component={Dashboard} />
            <Route path={`${path}/articles/:id?`} component={Articles} />
            <Route path={`${path}/authors/:id?`} component={Authors} />
            <Route path={`${path}/categories/:id?`} component={Categories} />
            <Route path={`${path}/surveys/:id?`} component={Surveys} />
            <Route path={`${path}/metrics/`} component={Metrics} />
            <Route path={`${path}/errors/:id?`} component={Errors} />
          </Switch>
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state: AppState) => {
  return {
    admin: state.auth.admin,
  };
};

const mapDispatchToProps = (dispatch: ThunkDispatch<any, any, AnyAction>) => {
  return {
    loadDashboard: () => dispatch(loadDashboardCreator()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(Admin);
